import { useUserData } from '@/services/user';
import { AvatarProps as ChakraAvatarProps } from '@chakra-ui/react';
import styleguide from '@common/styleguide';
import React, { FC } from 'react';
import Avatar from './Avatar';

const InviterAvatar: FC<ChakraAvatarProps> = (props) => {
    const { incomingPartnershipInvite } = useUserData();
    if (!incomingPartnershipInvite) return <></>;

    return incomingPartnershipInvite?.inviterAvatar ? (
        <Avatar avatar={incomingPartnershipInvite.inviterAvatar} {...props} />
    ) : (
        <Avatar
            firstName={incomingPartnershipInvite.inviterName}
            background={styleguide.colors.blueBright}
            {...props}
        />
    );
};

export default InviterAvatar;
